export default {
    props: {
        value: {
            type: Object,
            default () {
              return {}
            }
        },
        api: {
            type: String,
            default: ''
        },
        lazyLoadApi: { // ????????api
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default () {
              return []
            }
        },
        page: {
            type: Boolean,
            default: true
        },
        params: {
            type: Object,
            default () {
              return {}
            }
        },
        autoSearch: {
            type: Boolean,
            default: true
        },
        rowKey: {
            type: [String, Function],
            default: 'id'
        },
        disHover: { // 是否有Hover效果
            type: Boolean,
            default: false
        },
        lazyLoadParamNames: { // 懒加载参数标识 key为每行对象的key值，value为要传递给后端的参数名称
            type: [Object, Array],
            default () {
                return {}
            }
        },
        // 懒加载
        lazy: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        autoId: {
            type: Boolean,
            default: false
        },
        autoHeight: {
            type: Boolean,
            default: false
        },
        fixedHeight: { // 固定高度 优先级最高
            type: [Number,String]
        },
        pageSize: {
            type: Number,
            default: 25
        },
        pager: {
            type: Array,
            default () {
                return [10, 25, 50, 100]
            }
        },
        payload: {
            type: Object,
            default () {
                return {}
            }
        },
        showButton: {
            type: Boolean,
            default: true
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/layouts/data-grid-mixins.js